import { Grid } from '@chronosphereio/chrono-ui';

export type OptionsEditorGridProps = {
  /**
   * 1-3 `OptionsEditorColumn` components to render content in columns.
   */
  children: React.ReactNode;
};

/**
 * Top level grid container used to lay out content for editing in panel
 * options.
 */
export const OptionsEditorGrid = ({ children }: OptionsEditorGridProps) => {
  return (
    <Grid container spacing={8}>
      {children}
    </Grid>
  );
};
